import * as React from 'react';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';
import { chipBase } from 'ui/Chip/chipCssDefs';

export interface ChipProps extends Omit<MuiChipProps, 'color'> {
  /**
   * Color of the component. Expanded to include success, warning, and internal
   */
  color?:
    | MuiChipProps['color']
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'internal';
}

export type ChipColors = NonNullable<ChipProps['color']>;

/**
 * Bamboo flavored Chip component with additional color themes.
 *
 * Demo:
 * [Storybook](http://tock-assets.tocktix.com/styleguide/dashboard/?path=/docs/components-chip--playground)
 * /**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Chip: React.FunctionComponent<React.PropsWithChildren<ChipProps>> = ({
  color = 'default',
  label,
  ...rest
}) => {
  return <MuiChip css={chipBase(color)} label={label} {...rest} />;
};

export default Chip;
